import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private reloadPage: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private category: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(
    private httpService: HttpService,
  ) { }

  setCategory(category){
    this.category.next(category)
  }

  getCategory(){
    return this.category
  }

  getListPage(page: number = 1, status: string = "", search: string = "") : Promise<any> {
    let params : HttpParams = new HttpParams()
    .append('page', String(page))
    .append('status', status)
    .append('paginate', '20')
    .append('search', search);

    return this.httpService.get(`admin/categories/list`, params)
  }

  getListPageAdmin(page: number = 1, status: string = "", search: string = "") : Promise<any> {
    let params : HttpParams = new HttpParams()
    .append('page', String(page))
    .append('status', status)
    .append('paginate', '20')
    .append('search', search);

    return this.httpService.get(`admin/categories-admin/list`, params)
  }


  setReload(){
    this.reloadPage.next(true)
  }

  getReload(): Observable<any>{
    return this.reloadPage
  }


  getFullListPage() : Promise<any> {
    return this.httpService.get(`admin/categories/fullList`)
  }

  getFullListPageAdmin(): Promise<any>{
    return this.httpService.get(`admin/categories-admin/fullList`)
  }

  getSimpleFullListPage() : Promise<any> {
    return this.httpService.get(`admin/categories/simplefullList`)
  }

  getSimpleFullListPageAdmin(): Promise<any>{
    return this.httpService.get(`admin/categories-admin/simplefullList`)
  }

  getProductBySku(sku: string ) : Promise<any> {
    return this.httpService.get(`admin/categories/${sku}/detail`);
  }

  getProductBySkuAdmin(sku: string ) : Promise<any> {
    return this.httpService.get(`admin/categories-admin/${sku}/detail`);
  }

  updateStatusById(id: string, status: string) : Promise<any> {
    return this.httpService.put(`admin/categories/${id}/status`, {status: status});
  }

  updateStatusByIdAdmin(id: string, status: string) : Promise<any> {
    return this.httpService.put(`admin/categories-admin/${id}/status`, {status: status});
  }

  add(category: object) : Promise<any> {
    return this.httpService.post(`admin/categories`, category);
  }

  addAdmin(category: Object): Promise<any> {
    return this.httpService.post('admin/categories-admin', category)
  }

  update(id:string, data:object){
    return this.httpService.post(`admin/categories/${id}/update`, data)
  }

  updateAdmin(id:string, data:object){
    return this.httpService.post(`admin/categories-admin/${id}/update`, data)
  }

  deleteCategory(id:string, option:string): Promise<any>{
    return this.httpService.delete(`admin/categories/${id}/${option}`)
  }

  removeCtgFromFather(ctgFather:string, ctgSon:string): Promise<any>{
    return this.httpService.post(`admin/categories/${ctgFather}/remove/${ctgSon}`)
  }

}
